// extracted by mini-css-extract-plugin
module.exports = {"box":"CopyUrlBox_box__Jbqsh","text":"CopyUrlBox_text__zvh7B","url":"CopyUrlBox_url__sgfGL","copied":"CopyUrlBox_copied__ZLB80","copyButton":"CopyUrlBox_copyButton__6_KS1"};